import CampaignPlatformType from '@/Enums/CampaignManagement/CampaignPlatformType.enum.ts';
import { Route } from '@/Enums/Routes/Route.enum';
import { CAMPAIGN_MANAGEMENT_ROW_TYPE } from '@/constants/campaignManagement';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { gridFilteredDescendantCountLookupSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const RENDERER_CLASSNAME = 'text-ellipsis whitespace-nowrap overflow-hidden text-[#2E87FD]';

const LinkRenderer = ({ children, ...props }) => (
  <Link className={classNames(RENDERER_CLASSNAME, 'hover:underline')} {...props}>
    {children}
  </Link>
);

LinkRenderer.propTypes = {
  children: PropTypes.any,
};

const TextRenderer = ({ children, campaignName, ...props }) => (
  <span className={RENDERER_CLASSNAME} title={campaignName} role='presentation' {...props}>
    {children}
  </span>
);

TextRenderer.propTypes = {
  children: PropTypes.any,
  campaignName: PropTypes.string,
};

const GroupingCell = ({ id, rowNode, row, handleExpand }) => {
  const apiRef = useGridApiContext();

  const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);
  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  const arrowDown = !rowNode.childrenExpanded;

  const handleClick = event => {
    if (rowNode.type !== 'group') {
      return;
    }

    handleExpand(id, !rowNode.childrenExpanded);

    event.stopPropagation();
  };

  const platformPrefix = row.platform === CampaignPlatformType.Google ? '/dv360' : '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingLeft: rowNode.depth ? `calc(15px * ${rowNode.depth})` : null,
      }}
    >
      {row.type === CAMPAIGN_MANAGEMENT_ROW_TYPE.CAMPAIGN ? (
        <LinkRenderer to={`${Route.CAMPAIGN_MANAGEMENT}${platformPrefix}/${row.campaignId}`}>
          {row.campaignName}
        </LinkRenderer>
      ) : row.type === CAMPAIGN_MANAGEMENT_ROW_TYPE.LINE_ITEM ? (
        <LinkRenderer
          to={`${Route.CAMPAIGN_MANAGEMENT}${platformPrefix}/${row.campaignId}?lineItemId=${row.lineItemId}`}
        >
          {row.campaignName}
        </LinkRenderer>
      ) : (
        <TextRenderer campaignName={row.campaignName}>{row.campaignName}</TextRenderer>
      )}
      {filteredDescendantCount ? (
        <IconButton onClick={handleClick} size='small' tabIndex={-1}>
          {arrowDown ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </IconButton>
      ) : null}
    </Box>
  );
};

GroupingCell.propTypes = {
  id: PropTypes.string,
  rowNode: PropTypes.object,
  row: PropTypes.object,
  handleExpand: PropTypes.func,
};

export default GroupingCell;
